<div class="condition" [ngClass]="{ fullWidth: fullWidth }">
  <div class="condition_short" tabindex="0" aria-label="Eckdaten im Überblick">
    <h5 class="condition__title">Eckdaten im Überblick</h5>
    <div
      class="condition__content"
      tabindex="0"
      [attr.aria-labelledby]="
        'title-kreditinstitut-' +
        conditionsData.id +
        ' text-kreditinstitut-' +
        conditionsData.id
      "
      #conditionContent
    >
      <p
        class="content__title"
        [attr.id]="'title-kreditinstitut-' + conditionsData.id"
      >
        Kreditinstitut
      </p>
      <p
        class="content__text"
        [attr.id]="'text-kreditinstitut-' + conditionsData.id"
      >
        {{ conditionsData?.bankProduct?.bankDetails?.bankName }}
      </p>
    </div>
    <!--    <hr [color]="'#dcdcdc'" [size]="'1'">-->
    <div
      class="condition__content"
      tabindex="0"
      [attr.aria-labelledby]="
        'title-kreditsumme-' +
        conditionsData.id +
        ' text-kreditsumme-' +
        conditionsData.id
      "
      #conditionContent
    >
      <p
        class="content__title"
        [attr.id]="'title-kreditsumme-' + conditionsData.id"
      >
        Kreditsumme
      </p>
      <p
        class="content__text"
        [attr.id]="'text-kreditsumme-' + conditionsData.id"
      >
        {{
          conditionsData?.offerResponse?.terms?.loanAmount.toLocaleString(
            "de-DE",
            { minimumFractionDigits: 0 }
          )
        }}
        €
      </p>
    </div>
    <!--    <hr [color]="'#dcdcdc'" [size]="'1'">-->
    <div
      class="condition__content months"
      tabindex="0"
      [attr.aria-labelledby]="
        'title-laufzeit-' +
        conditionsData.id +
        ' text-laufzeit-' +
        conditionsData.id
      "
      #conditionContent
    >
      <p
        class="content__title"
        [attr.id]="'title-laufzeit-' + conditionsData.id"
      >
        Laufzeit
      </p>
      <p class="content__text" [attr.id]="'text-laufzeit-' + conditionsData.id">
        {{ conditionsData.offerResponse.terms?.numberOfInstallments }} Monate
      </p>
    </div>
    <!--    <hr [color]="'#dcdcdc'" [size]="'1'">-->
    <div
      class="condition__content"
      tabindex="0"
      [attr.aria-labelledby]="
        'title-effektiver-jahreszins-sollzins-' +
        conditionsData.id +
        ' text-effektiver-jahreszins-sollzins-' +
        conditionsData.id
      "
      #conditionContent
    >
      <p
        class="content__title"
        [attr.id]="'title-effektiver-jahreszins-sollzins-' + conditionsData.id"
      >
      {{ getEffectiveInterestNominalInterestTitleForSantander() }}
      </p>
      <svg
        *ngIf="!conditionsData.offerResponse.terms.effectiveInterest || !conditionsData.offerResponse.terms.nominalInterest"
        id="Layer_1"
        data-name="Layer 1"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 39.81 30"
        aria-hidden="true"
      >
        <defs>
          <style>
            .cls-1 {
              fill: #606060;
              font-family: MyriadPro-Regular, "Myriad Pro";
              font-size: 12px;
            }

            .cls-2 {
              fill: #666;
            }
          </style>
        </defs>
        <path
          class="cls-2"
          d="M20.46,18.27l-4.12-3V6.65c0-.51-.41-.92-.92-.92h-.84c-.51,0-.92,.41-.92,.92v9.52c0,.29,.14,.57,.38,.74l4.85,3.52h0c.41,.3,.98,.21,1.29-.2l.49-.67c.14-.2,.2-.44,.17-.68-.04-.24-.17-.46-.37-.6Z"
          vector-effect="non-scaling-stroke"
        />
        <path
          class="cls-2"
          d="M22.35,26.11c0-.31,.06-.62,.18-.91-2.18,1.61-4.82,2.48-7.53,2.48-7,0-12.69-5.69-12.69-12.68S8,2.32,15,2.32s12.69,5.69,12.69,12.68c0,.7-.06,1.4-.17,2.09,.75-.49,1.58-.85,2.45-1.07,.02-.34,.04-.68,.04-1.02,0-6.07-3.66-11.54-9.26-13.86C15.13-1.18,8.68,.1,4.39,4.39-1,9.79-1.49,18.37,3.26,24.33c4.75,5.97,13.22,7.43,19.69,3.39-.39-.45-.6-1.02-.6-1.61Z"
          vector-effect="non-scaling-stroke"
        />
        <text class="cls-1" transform="translate(20.84 24.92)">
          <tspan x="0" y="0">24h</tspan>
        </text>
      </svg>
      <div
        *ngIf="conditionsData.offerResponse.terms.effectiveInterest && conditionsData.offerResponse.terms.nominalInterest"
        class="content__text-wrap"
      >
        <p
          class="content__text"
          [attr.id]="'text-effektiver-jahreszins-sollzins-' + conditionsData.id"
        >
          {{
            conditionsData.offerResponse.terms?.effectiveInterest.toLocaleString(
              "de-DE",
              { minimumFractionDigits: 2, maximumFractionDigits: 2 }
            )
          }} / {{
            conditionsData.offerResponse.terms?.nominalInterest.toLocaleString(
              "de-DE",
              { minimumFractionDigits: 2, maximumFractionDigits: 2 }
            )
          }}
          %
        </p>
        <app-hint
          class="interest-rate-hint"
          [displayCss]="'inline'"
          [hintData]=getInterestRateHintData()
        ></app-hint>
      </div>
    </div>
  </div>
  <div class="condition_long" tabindex="0" aria-label="Kosten im Überblick">
    <h5 class="condition__title">Kosten im Überblick</h5>
    <div
      class="condition__content"
      *ngIf="getMonthlyRateWithoutRsv() != null"
      tabindex="0"
      [attr.aria-labelledby]="
        'title-mtl-rate-' +
        conditionsData.id +
        ' text-mtl-rate-' +
        conditionsData.id
      "
      #conditionContent
    >
      <p
        class="content__title"
        [attr.id]="'title-mtl-rate-' + conditionsData.id"
      >
        mtl. Rate
      </p>
      <p
        class="content__text"
        [attr.id]="'text-mtl-rate-' + conditionsData.id"
      >
        {{ formatCurrency(getMonthlyRateWithoutRsv()!) }} €
      </p>
    </div>
    <div
      *ngIf="hasCreditProtectionSelected()"
      class="condition__content"
      tabindex="0"
      [attr.aria-labelledby]="
        'title-mtl-installment-' +
        conditionsData.id +
        ' text-mtl-installment-' +
        conditionsData.id
      "
      #conditionContent
    >
      <p
        class="content__title"
        [attr.id]="'title-mtl-installment-' + conditionsData.id"
      >
        mtl. Kreditschutz
      </p>
      <p
        *ngIf="isPreliminaryOffer()"
        class="content__text"
        [attr.id]="'text-mtl-installment-' + conditionsData.id"
      >
        nach Anbotsstellung
      </p>
      <p
        *ngIf="!isPreliminaryOffer()"
        class="content__text"
        [attr.id]="'text-mtl-installment-' + conditionsData.id"
      >
        {{ formatCurrency(getMonthlyCreditProtection()) }} €
      </p>
    </div>
    <div
      *ngIf="conditionsData.offerResponse.terms.accountFeeTotal"
      class="condition__content"
      tabindex="0"
      [attr.aria-labelledby]="
        'title-accountFeeTotal-' +
        conditionsData.id +
        ' text-accountFeeTotal-' +
        conditionsData.id
      "
      #conditionContent
    >
      <p
        class="content__title"
        [attr.id]="'title-accountFeeTotal-' + conditionsData.id"
      >
        mtl. Kontoführungsgebühr
      </p>
      <p
        class="content__text"
        [attr.id]="'text-accountFeeTotal-' + conditionsData.id"
      >
        {{
          conditionsData.offerResponse.terms.accountFeeTotal.toLocaleString(
            "de-DE",
            {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2
            }
          )
        }}
        €
      </p>
    </div>
    <div
      *ngIf="getMonthlyTotalCosts() != null"
      class="condition__content total"
      tabindex="0"
      [attr.aria-labelledby]="
        'title-gesamtkosten-' +
        conditionsData.id +
        ' text-gesamtkosten-' +
        conditionsData.id
      "
      #conditionContent
    >
      <p
        class="content__title"
        [attr.id]="'title-gesamtkosten-' + conditionsData.id"
      >
        <strong>mtl. Gesamtkosten</strong>
      </p>
      <p
        class="content__text"
        [attr.id]="'text-gesamtkosten-' + conditionsData.id"
      >
        <strong>{{ formatCurrency(getMonthlyTotalCosts()!) }} €</strong>
      </p>
    </div>
    <div
      *ngIf="conditionsData.offerResponse.terms.processingFeeTotal"
      class="condition__content"
      tabindex="0"
      [attr.aria-labelledby]="
        'title-proccessingFee-' +
        conditionsData.id +
        ' text-proccessingFee-' +
        conditionsData.id
      "
      #conditionContent
    >
      <p
        class="content__title"
        [attr.id]="'title-proccessingFee-' + conditionsData.id"
      >
        Bearbeitungsgebühr
      </p>
      <p
        class="content__text"
        [attr.id]="'text-proccessingFee-' + conditionsData.id"
      >
        {{
          conditionsData.offerResponse.terms?.processingFeeTotal.toLocaleString(
            "de-DE",
            {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2
            }
          )
        }}
        €
      </p>
    </div>
    <div
      *ngIf="conditionsData?.offerResponse?.terms?.lastInstallment"
      class="condition__content"
      tabindex="0"
      [attr.aria-labelledby]="
        'title-lastInstallment-' +
        conditionsData.id +
        ' text-lastInstallment-' +
        conditionsData.id
      "
      #conditionContent
    >
      <p
        class="content__title"
        [attr.id]="'title-lastInstallment-' + conditionsData.id"
      >
        Schlussrate (letzte Monatsrate)
      </p>
      <p
        class="content__text"
        [attr.id]="'text-lastInstallment-' + conditionsData.id"
      >
        {{
          conditionsData?.offerResponse?.terms?.lastInstallment?.toLocaleString(
            "de-DE",
            {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2
            }
          )
        }}
        €
      </p>
    </div>
    <div
      class="condition__content"
      tabindex="0"
      [attr.aria-labelledby]="
        'title-gesamtbetrag-' +
        conditionsData.id +
        ' text-gesamtbetrag-' +
        conditionsData.id
      "
      #conditionContent
    >
      <p
        class="content__title"
        [attr.id]="'title-gesamtbetrag-' + conditionsData.id"
      >
        zu zahlender Gesamtbetrag
      </p>
      <svg
        *ngIf="
          !conditionsData.offerResponse.terms.loanTotalAmount &&
          conditionsData.bankProduct.bankDetails.bankGateway === 'OBERBANK'
        "
        id="Layer_1"
        data-name="Layer 1"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 39.81 30"
      >
        <defs>
          <style>
            .cls-1 {
              fill: #606060;
              font-family: MyriadPro-Regular, "Myriad Pro";
              font-size: 12px;
            }

            .cls-2 {
              fill: #666;
            }
          </style>
        </defs>
        <path
          class="cls-2"
          d="M20.46,18.27l-4.12-3V6.65c0-.51-.41-.92-.92-.92h-.84c-.51,0-.92,.41-.92,.92v9.52c0,.29,.14,.57,.38,.74l4.85,3.52h0c.41,.3,.98,.21,1.29-.2l.49-.67c.14-.2,.2-.44,.17-.68-.04-.24-.17-.46-.37-.6Z"
          vector-effect="non-scaling-stroke"
        />
        <path
          class="cls-2"
          d="M22.35,26.11c0-.31,.06-.62,.18-.91-2.18,1.61-4.82,2.48-7.53,2.48-7,0-12.69-5.69-12.69-12.68S8,2.32,15,2.32s12.69,5.69,12.69,12.68c0,.7-.06,1.4-.17,2.09,.75-.49,1.58-.85,2.45-1.07,.02-.34,.04-.68,.04-1.02,0-6.07-3.66-11.54-9.26-13.86C15.13-1.18,8.68,.1,4.39,4.39-1,9.79-1.49,18.37,3.26,24.33c4.75,5.97,13.22,7.43,19.69,3.39-.39-.45-.6-1.02-.6-1.61Z"
          vector-effect="non-scaling-stroke"
        />
        <text class="cls-1" transform="translate(20.84 24.92)">
          <tspan x="0" y="0">24h</tspan>
        </text>
      </svg>
      <p
        *ngIf="getAmountDue()"
        class="content__text"
        [attr.id]="'text-gesamtbetrag-' + conditionsData.id"
      >
        {{ formatCurrency(getAmountDue()!) }}
        €
      </p>
    </div>
    <div
      class="condition__content"
      tabindex="0"
      [attr.aria-labelledby]="
        'title-gebuhren-' +
        conditionsData.id +
        ' text-gebuhren-' +
        conditionsData.id
      "
      #conditionContent
    >
      <p
        class="content__title"
        [attr.id]="'title-gebuhren-' + conditionsData.id"
      >
        Zinsen und Gebühren
      </p>
      <p
        *ngIf="
          conditionsData.bankProduct.bankDetails.bankGateway !== 'OBERBANK'
        "
        class="content__text"
        [attr.id]="'text-gesamtbetrag-' + conditionsData.id"
      >
        {{
          getInterestAndFees() == null
            ? "-"
            : formatCurrency(getInterestAndFees()!) + " €"
        }}
      </p>
    </div>
    <div
      *ngIf="getCreditProtectionPackageName() as packageName"
      class="condition__content"
      tabindex="0"
      [attr.aria-labelledby]="
        'title-kreditschutz-total-' +
        conditionsData.id +
        ' text-kreditschutz-total-' +
        conditionsData.id
      "
      #conditionContent
    >
      <p
        class="content__title"
        [attr.id]="'title-kreditschutz-total-' + conditionsData.id"
      >
        Kreditschutz ({{ packageName }})
      </p>
      <p
        *ngIf="getCreditProtectionTotal() != null"
        class="content__text"
        [attr.id]="'text-kreditschutz-total-' + conditionsData.id"
      >
        {{ formatCurrency(getCreditProtectionTotal()!) }} €
      </p>
      <p
        *ngIf="getCreditProtectionTotal() == null"
        class="content__text"
        [attr.id]="'text-kreditschutz-total-' + conditionsData.id"
      >
        {{ isPreliminaryOffer() ? "nach Anbotsstellung" : "-" }}
      </p>
    </div>
  </div>
</div>
<p
  class="explanation-text"
  *ngIf="
    showInterestExplanation &&
    conditionsData.bankProduct.product.productDetails.interestDetails
      .interestCalculation.length > 0
  "
>
  Diese Angaben beruhen auf der Berechnung mit dem Zins, den 2/3 aller
  angenommenen Kunden erhalten.
</p>
